/**
 * Created by robert.lavoie on 6/16/17.
 */


import { Component } from '@angular/core';

/**
 *
 * @class
 * CustomerSiteColumnTextComponent
 *
 *
 * @description
 *
 * A text column will either be injected html when previewing or on the display side
 * Or a Quill inline text editor when editing
 *
 * The Quill inline text editor will automatically saves your changes every 5 seconds
 *
 * All text headings are styled according to the theme color
 *
 */
@Component({
  templateUrl: 'customer-site-column-text.component.html',
  selector: 'customer-site-column-text',
  styleUrls: ['./customer-site-column-text.component.scss'],
})
export class CustomerSiteColumnTextComponent {
  constructor() {}
}
